/**
 * FE bill-no matching aligned with backend BillUtils.ambiguousCharVariants (0/O, 1/I).
 */
export const ambiguousCharVariants = (billNo?: string | null): string[] => {
  if (!billNo) {
    return [];
  }
  const trimmed = billNo.trim();
  if (!trimmed) {
    return [];
  }
  return expandAmbiguousCharVariants(trimmed);
};

const expandAmbiguousCharVariants = (billNo: string): string[] => {
  const chars = billNo.split("");
  const ambiguousIndices: number[] = [];
  const isZeroOrO: boolean[] = [];

  for (let i = 0; i < chars.length; i++) {
    const c = chars[i];
    if (c === "0" || c === "O" || c === "o") {
      ambiguousIndices.push(i);
      isZeroOrO.push(true);
    } else if (c === "1" || c === "I" || c === "i") {
      ambiguousIndices.push(i);
      isZeroOrO.push(false);
    }
  }

  if (ambiguousIndices.length === 0) {
    return [billNo];
  }

  const variantCount = 1 << ambiguousIndices.length;
  const variants = new Set<string>();
  for (let mask = 0; mask < variantCount; mask++) {
    const variant = [...chars];
    for (let j = 0; j < ambiguousIndices.length; j++) {
      const idx = ambiguousIndices[j];
      const useLetter = ((mask >> j) & 1) === 1;
      if (isZeroOrO[j]) {
        variant[idx] = useLetter ? "O" : "0";
      } else {
        variant[idx] = useLetter ? "I" : "1";
      }
    }
    variants.add(variant.join(""));
  }
  return Array.from(variants);
};

export const isBillNoMatch = (
  left?: string | null,
  right?: string | null,
): boolean => {
  if (!left?.trim() || !right?.trim()) {
    return false;
  }
  const leftVariants = ambiguousCharVariants(left);
  if (leftVariants.length === 0) {
    return false;
  }
  return ambiguousCharVariants(right).some((variant) =>
    leftVariants.some((lv) => lv.toLowerCase() === variant.toLowerCase()),
  );
};
